import Meta from '@/components/common/Meta'

import CollegeStudentMovingPage from '@/v2/components/pages/landing-pages/college-student-moving-page'
import { LANDING_PAGES_META_CONTENTS } from '@/v2/constants/pages/landing-pages/meta/landing-pages-meta-content'
import { metaImages, ogImages } from '@/v2/constants/pages/landing-pages/collage-student-moving-page'

interface CollegeStudentMovingPageProps {}

const Page: React.FC<CollegeStudentMovingPageProps> = () => {
  return (
    <>
      <Meta
        title={
          LANDING_PAGES_META_CONTENTS.collage_student_moving.title ?? LANDING_PAGES_META_CONTENTS.default?.title ?? ''
        }
        keywords={
          LANDING_PAGES_META_CONTENTS.collage_student_moving?.keywords ??
          LANDING_PAGES_META_CONTENTS.default?.keywords ??
          ''
        }
        description={
          LANDING_PAGES_META_CONTENTS.collage_student_moving?.description ??
          LANDING_PAGES_META_CONTENTS.default?.description ??
          ''
        }
        openGraph={{
          images: ogImages
        }}
        searchImages={metaImages}
      />

      <CollegeStudentMovingPage />
    </>
  )
}

export default Page
